var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveGrokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82739 7.70288L10.7801 1.71602V1.72164L12.4995 0C12.4688 0.0439032 12.4376 0.0866425 12.4069 0.129382C11.1004 1.93087 10.4625 2.81177 10.9744 5.016L10.9714 5.01264C11.3243 6.513 10.9466 8.1769 9.72751 9.39751C8.19037 10.9376 5.73076 11.2804 3.70536 9.89401L5.11765 9.23962C6.41023 9.74777 7.82474 9.52466 8.841 8.5069C9.85763 7.48915 10.086 6.00712 9.57488 4.77341C9.47776 4.53975 9.18674 4.48088 8.98312 4.63162L4.82739 7.70288ZM3.96974 8.44913L3.96865 8.45026L0 12C0.251612 11.6531 0.563989 11.325 0.875635 10.9972C1.75463 10.0725 2.62687 9.156 2.09475 7.86076C1.38225 6.12752 1.797 4.0965 3.11663 2.77538C4.48837 1.40327 6.50848 1.05714 8.19563 1.75237C8.56913 1.89113 8.89462 2.08876 9.14812 2.27252L7.73926 2.92388C6.42749 2.373 4.92451 2.74764 4.00726 3.66601C2.76673 4.90688 2.51588 7.05863 3.96974 8.44913Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGrokIcon);
export default __webpack_public_path__ + "static/media/active-grok-icon.778051e5d27d9404d7541505968fa9ae.svg";
export { ForwardRef as ReactComponent };